import React from 'react'
import { Grid, Box } from '@mui/material'
import ProfileSection from './ProfileSection'
import FeaturesSection from './FeaturesSection'
import AccountsSection from './AccountsSection'
import { useUser } from 'store'

const Profile = () => {
  const [user] = useUser()

  if (!user) {
    return null
  }

  const accountsData = {
    name: 'Main Account',
    children: user?.accounts ?? []
  }  

  return (
    <Box sx={{ pb: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={7}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ProfileSection user={user} />
            </Grid>
            <Grid item xs={12}>
              <FeaturesSection />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5}>
          <AccountsSection accounts={accountsData} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Profile
